// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"387ae02e","453":"9e6742f9","455":"37734a31"}[chunkId] + ".chunk.js";
};